import { I18nextTranslationKeys } from '@/i18n/i18next';

import { ChannelProviderEnum, ChannelTypeEnum } from '../types';

export const CHANNEL_PROVIDERS_WITH_STREAM_URL: ChannelProviderEnum[] = [
  ChannelProviderEnum.STACKSCALE,
  ChannelProviderEnum.STREAM,
];

export const CHANNEL_PROVIDER_TO_TRANSLATION_KEY: Record<
  ChannelProviderEnum,
  I18nextTranslationKeys
> = {
  [ChannelProviderEnum.AUDITMEDIA]: 'Auditmedia',
  [ChannelProviderEnum.STACKSCALE]: 'Stackscale',
  [ChannelProviderEnum.STREAM]: 'Terceros',
  [ChannelProviderEnum.ACCESO]: 'Acceso',
};

export const CHANNEL_TYPE_TO_TRANSLATION_KEY: Record<ChannelTypeEnum, I18nextTranslationKeys> = {
  [ChannelTypeEnum.BACKUP]: 'Backup',
  [ChannelTypeEnum.TERRITORIAL_DISCONNECTION]: 'Desconexión territorial',
  [ChannelTypeEnum.MAIN_BROADCAST]: 'Emisión principal',
};
